import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../components/common/components/button/button.component';
import {MatCheckboxModule} from '@angular/material/checkbox';


@Component({
  selector: 'app-modified-changes',
  standalone: true,
  imports: [MatDialogModule, CommonModule, FormsModule, ButtonComponent, MatCheckboxModule],
  templateUrl: './modified-changes.component.html',
  styleUrl: './modified-changes.component.scss'
})
export class ModifiedChangesComponent {
  showAgain: boolean = false;
  mode: string = "";
  modeText: string = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ModifiedChangesComponent>, private dialog: MatDialog) {
    if (data) {
      if(data.mode == 'edit') {
        this.modeText = 'Discard'
      } else {
        this.modeText = 'Leave Page'
      }
      this.mode = data.mode
    }
  }

  onClose(event: any, mode: string): void {
    this.dialogRef.close({goBack: false, showAgain: false, mode: mode, event});
  }
  goBack(event: any, mode: string): void {
    this.dialogRef.close({goBack: true, showAgain: this.showAgain, mode: mode, event});
  }
  update(event: any): void {
    this.showAgain = event.checked
  }
}
